/**
 * Compute a sliding window of page numbers to render in a pagination bar.
 *
 * Returns up to `size` page numbers centered around `current` where possible,
 * clamped against the start/end of [1, total]. When `total <= size`, returns
 * every page. When `total <= 0`, returns an empty array.
 *
 * @param current - The active page (1-indexed).
 * @param total - Total number of pages.
 * @param size - Maximum count of page numbers in the window. Defaults to 7.
 */
export function getPageWindow(current: number, total: number, size = 7): number[] {
	if (total <= 0) return [];
	if (total <= size) {
		return Array.from({ length: total }, (_, i) => i + 1);
	}
	const half = Math.floor(size / 2);
	let start: number;
	if (current <= half + 1) {
		start = 1;
	} else if (current >= total - half) {
		start = total - size + 1;
	} else {
		start = current - half;
	}
	return Array.from({ length: size }, (_, i) => start + i);
}
